import {SectionSkeleton} from '../../models/form/SectionSkeleton';
import SectionConfiguration from '../../models/form/SectionConfiguration';
import {SectionView} from '../../models/form/SectionView';
import {LanguageId} from '../../models/utils/Languages';
import {FieldView} from '../../models/form/FieldView';
import FieldConfiguration from '../../models/form/FieldConfiguration';

export function getSectionConfiguration(id: string, configurations: SectionConfiguration[]): SectionConfiguration | undefined {
  return configurations.find((x) => x.id === id);
}

export function getFieldConfiguration(id: string, configurations: SectionConfiguration[]): FieldConfiguration | undefined {
  return configurations.map((x) => x.fields).flat(1).find((x) => x.id === id);
}

export function toSections(
  skeletons: SectionSkeleton[],
  activeLanguage: LanguageId,
  defaultLanguage: LanguageId,
  configurations: SectionConfiguration[],
): SectionView[] {
  const sections = skeletons.map((x) => {
    const configuration = getSectionConfiguration(x.id, configurations);
    if (configuration) {
      const fields: FieldView[] = x.fields.map((fieldSkeleton) => {
        const fieldConfiguration = getFieldConfiguration(fieldSkeleton.id, configurations);
        if (fieldConfiguration) {
          return fieldConfiguration.toView(activeLanguage, defaultLanguage, fieldSkeleton.required);
        }
        return undefined;
      }).filter((mayBeField) => mayBeField !== undefined).map((field) => <FieldView>field);
      return configuration.toView(activeLanguage, defaultLanguage, fields);
    }
    return undefined;
  }).filter((x) => x !== undefined).map((x) => <SectionView>x);
  return sections;
}
